// Trigger Supabase Google OAuth using the project's redirect contract.
// Same redirect path used by email magic links: `/auth/callback`.
// Desktop uses a popup so Chrome bounce-tracking does not treat this
// origin as a redirect hop and wipe storage when the browser closes.
import { getOAuthRedirectTo } from "@/lib/authRedirect";
import { supabase } from "@/lib/supabase";

export const BB_AUTH_COMPLETE_MESSAGE = "bb-auth-complete";

function shouldUseOAuthPopup(): boolean {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(display-mode: standalone)").matches) return false;
  return !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

export function beginGoogleSignIn() {
  if (!supabase) {
    console.error(
      "Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your environment."
    );
    return;
  }

  void (async () => {
    const redirectTo = getOAuthRedirectTo();
    if (import.meta.env.DEV || /vercel\.app$/i.test(window.location.hostname)) {
      console.info(
        "[auth] OAuth redirectTo (allow this in Supabase → Auth → URL Configuration → Redirect URLs):\n",
        redirectTo
      );
    }
    const usePopup = shouldUseOAuthPopup();
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo,
        skipBrowserRedirect: usePopup,
      },
    });

    if (error) {
      console.error("Google sign-in error:", error);
      return;
    }
    if (usePopup && data?.url) {
      const popup = window.open(data.url, "bb-google-oauth", "popup=yes,width=480,height=720");
      if (!popup) window.location.assign(data.url);
    }
  })();
}
